import * as React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorImageSVG } from './ErrorImageSVG'

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div className='wrapper-error container-fluid h-100'>
      <div role='alert' className='mt-4'>
        <div className='row text-center'>
          <div className='col-md-7 col-xs-12'>
            <ErrorImageSVG />
          </div>
          <div className='col-md-5 col-xs-12 text-left d-flex align-items-center'>
            <div>
              <pre className='font-weight-bold mb-0'>Ha ocurrido un error:</pre>
              <pre>{error.message}</pre>
              <button className='btn btn-danger' onClick={resetErrorBoundary}>
                Intentar nuevamente!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function AutoEvaluacionesErrorBoundary(props) {
  return <ErrorBoundary FallbackComponent={ErrorFallback} {...props} />
}
